import React from 'react';
import PropTypes from 'prop-types';

import { topBarStyles } from '@constants/mui-theme';

import { Progress } from '@mui';

const LoaderIcon = ({ color }) => (
  <div style={topBarStyles.loader}>
    <Progress size={30} thickness={3} progressColor={color} />
  </div>
);

LoaderIcon.propTypes = {
  color: PropTypes.string
};

export default LoaderIcon;
